import Vue from 'vue'
import Cognito from './cognitoDriver'
import config from '../config/'

Vue.use(Cognito, config.AWSDriverConfig)

export default new Cognito()
